import React, { useState, useEffect, state } from 'react';
import HeadSub from '../../../../components/comm/HeadSub';
import ToastPopup from '../../../../components/comm/ToastPopup';
import MobileTelecom from '../../../../components/box/MobileTelecom';
import style from './MobileIdentity.module.css';
import URL from '../../../../constants/url';
import { useNavigate } from "react-router-dom";
import { BottomSheet } from 'react-spring-bottom-sheet';
import 'react-spring-bottom-sheet/dist/style.css';
import {
    getConvertToFullBirth,
    getDpAuthHpSignIn,
    getDpAuthSendSms,
    getDpAuthSmsCheck,
    getIsBirthSix
} from '../../../../assets/js/comm';

const MobileIdentity = () => {
    const navigate = useNavigate();

    const [step, setStep] = useState(1);
    const [toast, setToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [open, setOpen] = useState(false);

    const [name, setName] = useState('');
    const [birth, setBirth] = useState('');
    const [genderCode, setGenderCode] = useState('');
    const [telecom, setTelecom] = useState('');
    const [phone, setPhone] = useState('');
    const [verificationCode, setVerificationCode] = useState('');

    const [timeLeft, setTimeLeft] = useState(180); // 3분 = 180초
    const [isTimeout, setIsTimeout] = useState(false);

    const onDismiss = () => setOpen(false);

    const lengthChk = (e) => {
        if (e.target.value.length > e.target.maxLength) {
            e.target.value = e.target.value.slice(0, e.target.maxLength);
        }
    };

    const onTelecomSelect = (selectedTelecom) => {
        setTelecom(selectedTelecom);
        setOpen(false);
    };

    useEffect(() => {
        if (step >= 5 && timeLeft > 0) {
            const timer = setInterval(() => {
                setTimeLeft((prev) => prev - 1);
            }, 1000);
            return () => clearInterval(timer);
        } else if (timeLeft === 0) {
            setIsTimeout(true);
        }
    }, [timeLeft, step]);

    const formatTime = (seconds) => {
        const min = String(Math.floor(seconds / 60)).padStart(2, '0');
        const sec = String(seconds % 60).padStart(2, '0');
        return `${min}:${sec}`;
    };

    const handleNext = () => {

        if(!name) {
            setToastMessage("이름을 입력해주세요.");
            setToast(true);
            return false;
        }

        if(step > 1 && !birth) {
            setToastMessage("생년월일 입력해주세요");
            setToast(true);
            return false;
        } else {
            if( step > 1 && !getIsBirthSix(birth)) {
                setToastMessage("생년월일 형식이 잘못 되었습니다.");
                setToast(true);
                return false;
            }
        }

        if(step > 1 && !genderCode) {
            setToastMessage("주민등록번호 뒷자리 첫번째 번호를 입력해주세요");
            setToast(true);
            return false;
        }

        if(step > 2 && !telecom) {
            setToastMessage("통신사를 선택해 주세요");
            setToast(true);
            return false;
        }

        if(step > 3 && !phone) {
            setToastMessage("휴대폰 번호를 입력해주세요");
            setToast(true);
            return false;
        } else {
            // 휴대폰 번호 입력 단계에서 인증번호 요청 버튼 클릭
            if( step > 3 && phone.length < 11 ) {
                setToastMessage("휴대폰 번호를 11자리를 입력해주세요");
                setToast(true);
                return false;
            } else if ( step === 4 && phone.length === 11 ) { // 1회만 사용됨.. 이후에는 인증번호 재전송에서 사용됨.
                // 인증문자 발송
                handleOnSendSms();
            }
        }

        if( step === 5 && !verificationCode ) {
            setToastMessage("인증번호를 입력해주세요");
            setToast(true);
            return false;
        } else if( step === 5 && verificationCode ) {
            // 인증문자 확인
            handleOnChenkAuthNo();
        }

        if( step < 5 ) {
            setStep(step + 1);
        }
    };

    /**
     * 휴대폰 인증문자 전송
     */
    const handleOnSendSms = () => {

        const user = {
            usrNm: name
            , mblNo : phone
        };

        getDpAuthSendSms(user)
            .then((res) => {
                if(res === "success") {
                    setVerificationCode('');
                    setToastMessage("전송이 완료 되었습니다.");
                    setToast(true);
                    setTimeLeft(180);
                    setIsTimeout(false);
                    setStep(5);
                }
            })
            .catch( (err) => {
                console.log(" handleOnSendSms Error ", err);
                setToastMessage("전송에 실패 하였습니다.\n문제가 지속되면 관리자에 문의해주세요!");
                setToast(true);
            });
    };


    /**
     * 휴대폰 인증문자 확인
     */
    const handleOnChenkAuthNo = () => {

        getDpAuthSmsCheck(phone, verificationCode)
            .then((res) => {
                if(res === "success") {
                    setToastMessage("인증 확인이 완료 되었습니다.");
                    setToast(true);
                    setTimeout( () => {
                        navigate(URL.AGREECONDITIONS, { state: { usrNm: name, mblNo: phone, brthdy: getConvertToFullBirth(birth, genderCode), gendr: genderCode, usrSeCd: "11", statCd: "1" }});
                    }, 400);
                } else {
                    setToastMessage("인증번호가 잘못 되었습니다. 다시 입력해주세요.");
                    setToast(true);
                }
            })
            .catch( (err) => {
                console.log(" handleOnChenkAuthNo Error ", err);
                setToastMessage("인증번호가 잘못 되었습니다. 다시 입력해주세요.");
                setToast(true);
            })

    }


    /**
     * 인풋박스 텍스트 변경 이벤트 처리
     * @param e
     */
    const handleOnChangeInput = (e) => {

        const inputName = e.target.name;

        if(inputName === "birth") {



        }

    }


    useEffect(() => {
        if (step === 4 && verificationCode.length > 0) {
            setStep(5); // 인증번호 입력 시 자동으로 인증번호 입력란 노출
        }
    }, [verificationCode, step]);

    return (
        <>
            <HeadSub title="휴대폰 본인확인" />

            <div id="sub-content" data-layout="white">
                <div className="inner-wrap" data-padding="30">
                    <div className={style['content-box']}>
                        <strong className={style['title']}>
                            {step === 2 ? '생년월일을 입력해 주세요'
                                : step === 3 ? '통신사를 선택해주세요'
                                : step === 4 ? '휴대폰 번호를 입력해 주세요'
                                : step === 5 ? '인증번호를 입력해 주세요 '
                                : '이름을 입력해 주세요'
                            }

                        </strong>

                        {/* 인증번호 */}
                        {step >= 5 && (
                            <div className={style['input-wrap']}>
                                <div className='animation-2'>
                                <span className={style['input-tit']}>인증번호</span>
                                <div className={style['input-box']}>
                                    <input
                                        type="number"
                                        placeholder="인증번호를 입력해주세요"
                                        value={verificationCode}
                                        onChange={(e) => setVerificationCode(e.target.value)}
                                    />
                                    <span className={style['line']}></span>
                                    <button className={style['cancel-btn']} onClick={() => setVerificationCode('')}></button>
                                </div>
                                <div className={style['input-bottom']}>
                                    <span className={style['time']}>
                                        {isTimeout ? '인증시간 초과' : formatTime(timeLeft)}
                                    </span>
                                    <button
                                        className={style['request-btn']}
                                        disabled={!isTimeout}
                                        onClick={() => handleOnSendSms()}
                                    >
                                        <span>인증번호 재요청</span>
                                    </button>
                                </div>
                                </div>
                            </div>
                        )}

                        {/* 휴대폰 번호 */}
                        {step >= 4 && (
                            <div className={style['input-wrap']}>
                                <div className='animation-2'>
                                <span className={style['input-tit']}>휴대폰 번호</span>
                                <div className={style['input-box']}>
                                    <input
                                        type="number"
                                        placeholder="휴대폰 번호를 입력해주세요"
                                        value={phone}
                                        onChange={(e) => setPhone(e.target.value.trim())}
                                    />
                                    <span className={style['line']}></span>
                                </div>
                                </div>
                            </div>
                        )}

                        {/* 통신사 */}
                        {step >= 3 && (
                            <div className={style['input-wrap']}>
                                <div className='animation-2'>
                                <span className={style['input-tit']}>통신사</span>
                                <div className={style['input-box']} data-type-input="btn">
                                    <input
                                        type="button"
                                        placeholder={telecom || '통신사 선택'}
                                        className={style['telecom-input']}
                                        onClick={() => setOpen(true)}
                                        value={telecom}
                                        readOnly
                                    />
                                    <span className={style['line']}></span>
                                </div>
                                </div>
                            </div>
                        )}

                        {/* 생년월일 */}
                        {step >= 2 && (
                            <div className={style['input-wrap']}>
                                <div className='animation-2'>
                                <span className={style['input-tit']}>생년월일</span>
                                <div className={style['birth-input-box']}>
                                    <div className={style['input-box']}>
                                        <input
                                            type="number"
                                            name="birth"
                                            maxLength={6}
                                            value={birth}
                                            onChange={(e) => setBirth(e.target.value)}
                                            onInput={lengthChk}
                                            placeholder="YYMMDD"
                                        />
                                        <span className={style['line']}></span>
                                    </div>
                                    <div className={style['input-box']}>
                                        <input
                                            type="number"
                                            maxLength={1}
                                            value={genderCode}
                                            onChange={(e) => setGenderCode(e.target.value)}
                                            onInput={lengthChk}
                                            placeholder='0'
                                        />
                                        <span className={style['line']}></span>
                                        <span className={style['hideing']}>******</span>
                                    </div>
                                </div>
                                </div>
                            </div>
                        )}


                        {/* 이름 */}
                        {step >= 1 && (

                                <div className={style['input-wrap']}>
                                    <div className='animation-2'>
                                        <span className={style['input-tit']}>이름</span>
                                        <div className={style['input-box']}>
                                            <input
                                                type="text"
                                                placeholder="이름 입력"
                                                value={name}
                                                onChange={(e) => setName(e.target.value.trim())}
                                            />
                                            <span className={style['line']}></span>
                                        </div>
                                    </div>
                                </div>

                        )}

                    </div>

                    {/* 다음 버튼 */}
                    <div className="bottom-fixed-box">
                        <div className="inner-box">
                            <div className="btn-layout" data-btn-num="1">
                                <button
                                    className="btn"
                                    data-btn-type="fill-main"
                                    data-btn-size="lg"
                                    onClick={handleNext}
                                >
                                    <span>{step === 4 ? '인증번호 요청'
                                            : step < 5
                                            ? '다음'
                                            : '인증번호 확인'}
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* 토스트 */}
                    {toast && (
                        <ToastPopup
                            setToast={setToast}
                            message={toastMessage}
                        />
                    )}

                    {/* 통신사 바텀시트 */}
                    <BottomSheet

                        scrollLocking={false} // 내부 스크롤을 위해 BottomSheet 스크롤 잠금 해제
                        expandOnContentDrag={false} // 내용 드래그로 확장 방지

                        open={open}
                        onDismiss={onDismiss}
                        snapPoints={({ minHeight }) => minHeight}
                        blocking={true}
                    >
                        <MobileTelecom
                            onClose={onDismiss}
                            onSelect={onTelecomSelect}
                        />
                    </BottomSheet>

                </div>
            </div>
        </>
    );
};

export default MobileIdentity;
